// Dashboard.jsx
import React, { useState, useEffect, useContext } from "react";
import Card from "../utils/Card";
import { FiUsers, FiFileText, FiCheckCircle, FiTrendingUp, FiTrendingDown } from "react-icons/fi";
import api from "../../api";
import { AuthContext } from "../../contexts/AuthContext";
import Outreach from "../outreach/Outreach";
import "./Dashboard.css";

const Dashboard = ({ showToast, currentUser }) => {
  const { currentUser: contextUser } = useContext(AuthContext);
  const user = currentUser || contextUser;
  const [metrics, setMetrics] = useState({
    peopleIssued: { value: 0, comparison: null },
    dealsInProgress: { value: 0, comparison: null },
    closedDeals: { value: 0, comparison: null },
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) {
      setLoading(true);
      api
        .get("/dashboard/metrics")
        .then((response) => {
          setMetrics(response.data);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching dashboard metrics:", error);
          setLoading(false);
        });
    }
  }, [user]);

  if (loading) {
    return (
      <div style={{ padding: "1rem", textAlign: "center" }}>
        <p>Loading dashboard metrics...</p>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem', marginBottom: '2rem' }}>
        <Card 
          icon={<FiUsers />}
          title="People Issued"
          subtitle="Total people assigned to you"
          data={{
            value: metrics.peopleIssued.value,
            label: "contacts"
          }}
          comparison={metrics.peopleIssued.comparison}
          variant="primary"
        />
        
        <Card 
          icon={<FiFileText />}
          title="Deals in Progress"
          subtitle="Active deals requiring attention"
          data={{
            value: metrics.dealsInProgress.value,
            label: "active deals"
          }}
          comparison={metrics.dealsInProgress.comparison}
          variant="warning"
        />
        
        <Card 
          icon={<FiCheckCircle />}
          title="Closed Deals"
          subtitle="Successfully completed deals"
          data={{
            value: metrics.closedDeals.value,
            label: "completed"
          }}
          comparison={metrics.closedDeals.comparison}
          variant="success"
        />
      </div>
      
      <div>
        <h2 className="section-title">Outreach Efforts</h2>
        <Outreach showToast={showToast} currentUser={user} />
      </div>
    </div>
  );
};

export default Dashboard;
